import nextI18nextConfig from '../../next-i18next.config';

const localePrefixPattern = new RegExp(
  `^/(?:${nextI18nextConfig.i18n.locales.join('|')})(?=/|$)`,
  'i'
);

const getPathnameWithoutLocale = (pathname: string) =>
  pathname.replace(localePrefixPattern, '') || '/';

export default getPathnameWithoutLocale;
